import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ScrollContainer from "react-indiana-drag-scroll";
import API from "../../services/api";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import {
  SlOption,
  SlSelect,
  SlIcon,
  SlDrawer
} from "@shoelace-style/shoelace/dist/react";
import * as XLSX from "sheetjs-style";
import { toLakhs, getBrandOptions } from "../../utils/constants";
import { format, subMonths } from "date-fns";


function DailyVsEenadu() {
  const [data, setData] = useState([{}]);
  const [newspapers, setNewspapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType, setSelectedType] = useState("all");
  const [showBrands, setShowBrands] = useState(false);
  const [brandsData, setBrandsData] = useState({});
  const [mergeData, setMergeData] = useState({})
  const [totalForEachbrand,setTotalForEachbrand] = useState( {
    PAM: 0,
    PFM: 0,
    WFM: 0,
    UVM: 0,
  })
  function formatSpentValue(value) {
    value = +value
    if (value < 1000) {
      return `${value.toFixed(2)}`;
    } else if (value >= 1000 && value < 100000) {
      const kValue = (value / 1000).toFixed(2);
      return `${kValue}K`;
    } else if (value >= 100000 && value < 10000000) {
      const lValue = (value / 100000).toFixed(2);
      return `${lValue}L`;
    } else if (value >= 10000000) {
      const crValue = (value / 10000000).toFixed(2);
      return `${crValue}Cr`;
    } else {
      return 0;
    }
  }
  let totalNewspaperClients = 0,
    totalNewspaperRevenue = 0,
    totalFiniteClients = 0,
    totalFiniteRevenue = 0,
    totalW2NClients = 0,
    totalW2NRevenue = 0,
    totalUnivClients = 0,
    totalUnivRevenue = 0;

  // Sets to track unique brands
  const uniqueNewspaperBrands = new Set();
  const uniqueFiniteBrands = new Set();
  const uniqueW2NBrands = new Set();
  const uniqueUnivBrands = new Set();
    const handleRequestClose = (event) => {
      if (event.detail.source === "overlay") {
        event.preventDefault();
      }
    };
  function getDaysInMonth(selectedMonth) {
    if (!selectedMonth) return 30; // Default to 30 days in case of error

    const today = new Date(selectedMonth);
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();

    // If selected month is the current month, return today's date
    let today_date = new Date();
    if (
      today_date.getFullYear() === currentYear &&
      today_date.getMonth() === currentMonth
    ) {
      return today_date.getDate();
    }

    // Return last date of the selected month
    return new Date(currentYear, currentMonth + 1, 0).getDate();
  }
  const fetchNewspapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewspapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/sales_reports/dailyrevenue",
        method: "POST",
        responseType: "json",
        data: {
          newspaper: selectedNewspaper,
          month: selectedMonth,
          type: selectedType,
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if (res.data.userType !== -1) {
          setSelectedType(`${res.data.userType}`);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      let tableData = [];
      tableData.push([
        "Date",
        `${selectedNewspaper} Clients`,
        `${selectedNewspaper} Revenue`,
        "Finite Clients",
        "Finite Revenue",
        "Way2News Clients",
        "Way2News Revenue",
        "Newspaper Univ Clients",
        "Newspaper Univ Revenue",
        "Daily Client Conv%",
        "Daily Rev Conv%",
      ]);

      // Data Rows
      for (let index1 = 0; index1 < getDaysInMonth(selectedMonth); index1++) {
        const dateKey = new Date(year, month - 1, index1 + 1).getTime() / 1000;
        const rowData = data?.data?.[dateKey] || {};

        const newspaperAll = rowData[selectedNewspaper] || {
          clients: 0,
          revenue: 0,
        };
        const newspaperFinite = rowData[`${selectedNewspaper}_finite`] || {
          clients: 0,
          revenue: 0,
        };
        const w2nFinite = rowData["W2N_finite"] || { clients: 0, revenue: 0 };
        const newspaperUniv = rowData[`${selectedNewspaper}_univ`] || {
          clients: 0,
          revenue: 0,
        };

        const dailyClientConv = newspaperFinite.clients
          ? ((newspaperUniv.clients / newspaperFinite.clients) * 100).toFixed(
              2
            ) + "%"
          : "0%";

        const dailyRevConv = newspaperFinite.revenue
          ? ((newspaperUniv.revenue / newspaperFinite.revenue) * 100).toFixed(
              2
            ) + "%"
          : "0%";

        tableData.push([
          `${index1 + 1}-${month}-${year}`,
          newspaperAll.clients,
          newspaperAll.revenue,
          newspaperFinite.clients,
          newspaperFinite.revenue,
          w2nFinite.clients,
          w2nFinite.revenue,
          newspaperUniv.clients,
          newspaperUniv.revenue,
          dailyClientConv,
          dailyRevConv,
        ]);
      }

      // Total Row
      tableData.push([
        "Total",
        totalNewspaperClients,
        (totalNewspaperRevenue),
        totalFiniteClients,
        (totalFiniteRevenue),
        totalW2NClients,
        (totalW2NRevenue),
        totalUnivClients,
        (totalUnivRevenue),
        totalFiniteClients
          ? ((totalUnivClients / totalFiniteClients) * 100).toFixed(2) + "%"
          : "0%",
        totalFiniteRevenue
          ? ((totalUnivRevenue / totalFiniteRevenue) * 100).toFixed(2) + "%"
          : "0%",
      ]);
      const monthRows = getPreviousMonthsLabels(
        new Date(selectedMonth).getMonth(),
        new Date(selectedMonth).getFullYear()
      )?.map((monthName, index) => {
        const monthKey = (index + 1).toString();
        const newspaperAll =
          data?.yearData[monthKey]?.[`${selectedNewspaper}`] || {};
        const newspaperFinite =
          data?.yearData[monthKey]?.[`${selectedNewspaper}_finite`] || {};
        const way2newsFinite =
          data?.yearData[monthKey]?.[`Way2news_finite`] || {};
        const newspaperUniv =
          data?.yearData[monthKey]?.[`${selectedNewspaper}_univ`] || {};

        const clientConv =
          newspaperFinite.clients && newspaperUniv.clients
            ? ((newspaperUniv.clients / newspaperFinite.clients) * 100).toFixed(
                2
              )
            : "0";

        const revConv =
          newspaperFinite.revenue && newspaperUniv.revenue
            ? ((newspaperUniv.revenue / newspaperFinite.revenue) * 100).toFixed(
                2
              )
            : "0";

        return [
          monthName[0],
          newspaperAll.clients || 0,
          (newspaperAll.revenue || 0),

          newspaperFinite.clients || 0,
          (newspaperFinite.revenue || 0),

          way2newsFinite.clients || 0,
          (way2newsFinite.revenue || 0),

          newspaperUniv.clients || 0,
          (newspaperUniv.revenue || 0),

          clientConv,
          revConv,
        ];
      });
      const worksheet = XLSX.utils.aoa_to_sheet([...tableData,...monthRows]);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, `Daily vs ${selectedNewspaper}`);
      XLSX.writeFile(workbook, `DailyVsNewspaper.xlsx`);
    } catch (error) {
      console.error(error, "Daily Vs Newspaper");
    } finally {
      setDownloadLoader(false);
    }
  };
  useEffect(() => {
    fetchNewspapers();
  }, []);

  const handleMonthChange = (date) => {
    setSelectedMonth(date);
    setMonth(date.getMonth() + 1);
    setYear(date.getFullYear());
  };

  function getPreviousMonthsLabels(currentMonth, year) {
    const months = [];
    let date = new Date(year, currentMonth - 1, 1);

    for (let i = 0; i < currentMonth; i++) {
      months.push([format(date, "MMM_yy"), date.getMonth() + 1]);
      date = subMonths(date, 1);
    }

    return months;
  }

  useEffect(() => {
    fetchData();
  }, [selectedNewspaper, selectedType, selectedMonth]);

  const buildMapping = () => {
    const indexes = {
      PAM: 0,
      PFM: 1,
      WFM: 2,
      UVM: 3
    }
    let mergedata = {}
    let sumOfBrands = {
      PAM: 0,
      PFM: 0,
      WFM: 0,
      UVM: 0,
    }
    Object.keys(brandsData).forEach((key, index) => {
      if (index === 0) {
        brandsData[key]?.forEach((item, _) => {
          if(!mergedata.hasOwnProperty(item.brand_name)) mergedata[item.brand_name] = [0, 0, 0, 0,item.category, item.sales_name,item.brand_location]
          mergedata[item.brand_name][indexes[key]] += item.amount;
          sumOfBrands[key] += item.amount
        })
      }
      else {
        brandsData[key]?.forEach((item, _) => {
          if (mergedata.hasOwnProperty(item.brand_name)) {
            mergedata[item.brand_name][indexes[key]] += item.amount;
            sumOfBrands[key] += item.amount
          }
        })
      }
    })
    setTotalForEachbrand(sumOfBrands);
    setMergeData(mergedata)
  }



  const downloadBrandWiseData = (mergeData, totalForEachbrand, selectedNewspaper) => {
    try {
      const sheetData = [];

      // Define a reusable border style
      const borderStyle = {
        top: { style: "thin", color: { rgb: "000000" } },
        bottom: { style: "thin", color: { rgb: "000000" } },
        left: { style: "thin", color: { rgb: "000000" } },
        right: { style: "thin", color: { rgb: "000000" } },
      };

      // Header row (bold with border)
      sheetData.push([
        { v: "Brand Name", s: { font: { bold: true }, border: borderStyle } },
        { v: `${selectedNewspaper} All`, s: { font: { bold: true }, border: borderStyle } },
        { v: `${selectedNewspaper} Finite`, s: { font: { bold: true }, border: borderStyle } },
        { v: "W2N Finite", s: { font: { bold: true }, border: borderStyle } },
        { v: "W2N Univ", s: { font: { bold: true }, border: borderStyle } },
      ]);

      // Data rows with background + border
      Object.keys(mergeData).forEach((brand) => {
        const row = [
          { v: brand, s: { border: borderStyle } },
          ...mergeData[brand].map((value) => ({
            v: value || 0,
            s: {
              fill: {
                fgColor: {
                  rgb: value > 0 ? "C6EFCE" : "FFC7CE" 
                }
              },
              border: borderStyle
            }
          })),
        ];
        sheetData.push(row);
      });

      // Total row
      const totalRow = [
        { v: "Total", s: { font: { bold: true }, border: borderStyle } },
        ...["PAM", "PFM", "WFM", "UVM"].map((key) => {
          const value = totalForEachbrand[key] || 0;
          return {
            v: value,
            s: {
              font: { bold: true, color: { rgb: "000000" } },
              fill: {
                fgColor: {
                  rgb: value > 0 ? "C6EFCE" : "FFC7CE"
                }
              },
              border: borderStyle
            }
          };
        }),
      ];
      sheetData.push(totalRow);

      // Export
      const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Brand Wise Data");

      XLSX.writeFile(workbook, `BrandWiseData_${selectedNewspaper}.xlsx`);
    } catch (error) {
      console.error("Error downloading Excel:", error);
    }
  };



  useEffect(() => {
    if (Object.keys(brandsData).length) {
      buildMapping();
    }
  }, [brandsData]);

  return (
    <>
      <div className="flex gap-3 justify-between">
        <h5>Daily VS Eenadu</h5>
        <aside className="flex flex-wrap items-end gap-4 p-4 bg-white rounded-md shadow-sm">
          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Team</label>
            <SlSelect
              size="small"
              value={selectedType}
              onSlChange={(e) => setSelectedType(e.target.value)}
              className="min-w-[150px]"
            >
              {data?.userType === -1 && <SlOption value="all">All</SlOption>}
              {getBrandOptions(data?.userType, localStorage.getItem("email"))?.map(
                (type) => (
                  <SlOption key={type.value} value={type.value}>
                    {type.label}
                  </SlOption>
                )
              )}
            </SlSelect>
          </div>

          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Newspaper</label>
            <SlSelect
              size="small"
              value={selectedNewspaper}
              onSlChange={(e) => setSelectedNewspaper(e.target.value)}
              className="min-w-[150px]"
            >
              {newspapers.map((paper) => (
                <SlOption key={paper.name} value={paper.name}>
                  {paper.name}
                </SlOption>
              ))}
            </SlSelect>
          </div>

          <div className="flex flex-col">
            <label className="text-sm font-medium text-gray-700 mb-1">Select Month</label>
            <DatePicker
              selected={selectedMonth}
              onChange={handleMonthChange}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              className="dateChooser border border-gray-300 rounded-md px-2 py-1 text-sm"
            />
          </div>

          <div className="flex items-end">
            {downloadLoader ? (
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            ) : (
              <sl-tooltip content="Download" placement="top">
                <div
                  className="w-8 h-8 flex items-center justify-center bg-gray-100 hover:bg-gray-200 text-gray-700 hover:text-cyan-600 rounded-md cursor-pointer"
                  onClick={getdownloadData}
                >
                  <SlIcon library="lucide" name="download" />
                </div>
              </sl-tooltip>
            )}
          </div>
        </aside>

      </div>
      <ScrollContainer>
        <table className="table table-bordered tbodyscroll">
          <thead className="bg-yellow-300">
            <tr>
              <th></th>
              <th colSpan={2}>{selectedNewspaper} all</th>
              <th colSpan={2}>{selectedNewspaper} Mapped Finite</th>
              <th colSpan={2}>Way2news all mapped (finite)</th>
              <th colSpan={2}>Eenadu Finite Univ on Way2news</th>
              <th colSpan={2}>Way2news Vs {selectedNewspaper} %</th>
            </tr>
            <tr>
              <th>Date</th>
              <th>Clients</th>
              <th>Revenue</th>
              <th>Clients</th>
              <th>Revenue</th>
              <th>Clients</th>
              <th>Revenue</th>
              <th>Clients</th>
              <th>Revenue</th>
              <th>daily client conv%</th>
              <th>daily Rev conv%</th>
            </tr>
          </thead>
          {!loader && Object.keys(data?.data || {})?.length > 0 ? (
            <tbody>
              {Array.from(
                { length: getDaysInMonth(selectedMonth) },
                (_, index1) => {
                  const dateKey =
                    new Date(year, month - 1, index1 + 1).getTime() / 1000; // Convert to Unix timestamp (seconds)
                  const rowData = data?.data?.[dateKey] || {}; // Get the row data, or empty object if not found

                  const newspaperAll = rowData[selectedNewspaper] || {
                    clients: 0,
                    revenue: 0,
                  };
                  const newspaperFinite = rowData[
                    `${selectedNewspaper}_finite`
                  ] || { clients: 0, revenue: 0 };
                  const w2nFinite = rowData["W2N_finite"] || {
                    clients: 0,
                    revenue: 0,
                  };
                  const newspaperUniv = rowData[
                    `${selectedNewspaper}_univ`
                  ] || { clients: 0, revenue: 0 };

                  // Avoid division by zero
                  const dailyClientConv = newspaperFinite.clients
                    ? (
                        (newspaperUniv.clients / newspaperFinite.clients) *
                        100
                      ).toFixed(2)
                    : "0";

                  const dailyRevConv = newspaperFinite.revenue
                    ? (
                        (newspaperUniv.revenue / newspaperFinite.revenue) *
                        100
                      ).toFixed(2)
                    : "0";

                  // Accumulate totals
                  totalNewspaperClients += Number(newspaperAll.clients);
                  totalNewspaperRevenue += Number(newspaperAll.revenue);
                  totalFiniteClients += Number(newspaperFinite.clients);
                  totalFiniteRevenue += Number(newspaperFinite.revenue);
                  totalW2NClients += Number(w2nFinite.clients);
                  totalW2NRevenue += Number(w2nFinite.revenue);
                  totalUnivClients += Number(newspaperUniv.clients);
                  totalUnivRevenue += Number(newspaperUniv.revenue);

                  // Collect unique brands
                  newspaperAll.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueNewspaperBrands.add(brand.brand_name);
                    }
                  });
                  
                  newspaperFinite.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueFiniteBrands.add(brand.brand_name);
                    }
                  });
                  
                  w2nFinite.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueW2NBrands.add(brand.brand_name);
                    }
                  });
                  
                  newspaperUniv.brand_amounts?.forEach(brand => {
                    if (brand.brand_name) {
                      uniqueUnivBrands.add(brand.brand_name);
                    }
                  });

                  return (
                    <tr key={index1}>
                      <td className="!bg-orange-100">{`${
                        index1 + 1
                      }-${month}-${year}`}</td>
                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({
                            PAM: newspaperAll.brand_amounts,
                            PFM: newspaperFinite.brand_amounts,
                            WFM: w2nFinite.brand_amounts,
                            UVM: newspaperUniv.brand_amounts,
                          });
                        }}
                      >
                        {newspaperAll.clients || 0}
                      </td>
                      <td>{toLakhs(newspaperAll.revenue)}</td>
                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({
                            PFM: newspaperFinite.brand_amounts,
                            PAM: newspaperAll.brand_amounts,
                            WFM: w2nFinite.brand_amounts,
                            UVM: newspaperUniv.brand_amounts,
                          });
                        }}
                      >
                        {newspaperFinite.clients || 0}
                      </td>
                      <td>{toLakhs(newspaperFinite.revenue)}</td>
                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({
                            WFM: w2nFinite.brand_amounts,
                            PAM: newspaperAll.brand_amounts,
                            PFM: newspaperFinite.brand_amounts,
                            UVM: newspaperUniv.brand_amounts,
                          });
                        }}
                      >
                        {w2nFinite.clients || 0}
                      </td>
                      <td>{toLakhs(w2nFinite.revenue)}</td>
                      <td
                        className="text-blue-500 cursor-pointer"
                        onClick={() => {
                          setShowBrands(true);
                          setBrandsData({
                            UVM: newspaperUniv.brand_amounts,
                            PAM: newspaperAll.brand_amounts,
                            PFM: newspaperFinite.brand_amounts,
                            WFM: w2nFinite.brand_amounts,
                          });
                        }}
                      >
                        {newspaperUniv.clients || 0}
                      </td>
                      <td>{toLakhs(newspaperUniv.revenue)}</td>
                      <td>{dailyClientConv}%</td>
                      <td>{dailyRevConv}%</td>
                    </tr>
                  );
                }
              )}

              {/* Total Row */}
              <tr className="font-bold bg-gray-300">
                <td>Total</td>
                <td title={`Clients total: ${totalNewspaperClients}, unique: ${uniqueNewspaperBrands.size}`}>{uniqueNewspaperBrands.size}</td>
                <td title={`Revenue: ${toLakhs(totalNewspaperRevenue)}`}>{toLakhs(totalNewspaperRevenue)}</td>

                <td title={`Clients total: ${totalFiniteClients}, unique: ${uniqueFiniteBrands.size}`}>{uniqueFiniteBrands.size}</td>
                <td title={`Revenue: ${toLakhs(totalFiniteRevenue)}`}>{toLakhs(totalFiniteRevenue)}</td>

                <td title={`Clients total: ${totalW2NClients}, unique: ${uniqueW2NBrands.size}`}>{uniqueW2NBrands.size}</td>
                <td title={`Revenue: ${toLakhs(totalW2NRevenue)}`}>{toLakhs(totalW2NRevenue)}</td>

                <td title={`Clients total: ${totalUnivClients}, unique: ${uniqueUnivBrands.size}`}>{uniqueUnivBrands.size}</td>
                <td title={`Revenue: ${toLakhs(totalUnivRevenue)}`}>{toLakhs(totalUnivRevenue)}</td>

                <td>{totalFiniteClients ? ((totalUnivClients / totalFiniteClients) * 100).toFixed(2) : "0"}%</td>
                <td>{totalFiniteRevenue ? ((totalUnivRevenue / totalFiniteRevenue) * 100).toFixed(2) : "0"}%</td>
              </tr>


              {(() => {
                // let totalAllClients = 0,
                //   totalAllInsertions = 0,
                //   totalAllRevenue = 0,
                //   totalFiniteClients = 0,
                //   totalFiniteInsertions = 0,
                //   totalFiniteRevenue = 0,
                //   totalWay2newsClients = 0,
                //   totalWay2newsInsertions = 0,
                //   totalWay2newsRevenue = 0,
                //   totalUnivClients = 0,
                //   totalUnivInsertions = 0,
                //   totalUnivRevenue = 0;

                const monthRows = getPreviousMonthsLabels(
                  new Date(selectedMonth).getMonth(),
                  new Date(selectedMonth).getFullYear()
                )?.map((monthName, index) => {
                  const monthKey = (new Date(selectedMonth).getMonth() -  (index)).toString()
                  const newspaperAll =
                    data?.yearData[monthKey]?.[`${selectedNewspaper}`] || {};
                  const newspaperFinite =
                    data?.yearData[monthKey]?.[`${selectedNewspaper}_finite`] ||
                    {};
                  const way2newsFinite =
                    data?.yearData[monthKey]?.[`Way2news_finite`] || {};
                  const newspaperUniv =
                    data?.yearData[monthKey]?.[`Way2news_univ`] ||
                    {};

                  // Conversion calculations
                  const clientConv =
                    newspaperFinite.clients && newspaperUniv.clients
                      ? (
                          (newspaperUniv.clients / newspaperFinite.clients) *
                          100
                        ).toFixed(2)
                      : "0";

                  // const insertConv = newspaperFinite.insertions && newspaperUniv.insertions
                  //   ? ((newspaperUniv.insertions / newspaperFinite.insertions) * 100).toFixed(2)
                  //   : "0";

                  const revConv =
                    newspaperFinite.revenue && newspaperUniv.revenue
                      ? (
                          (newspaperUniv.revenue / newspaperFinite.revenue) *
                          100
                        ).toFixed(2)
                      : "0";

                  // Summing up totals
                  // totalAllClients += Number(newspaperAll.clients) || 0;
                  // totalAllInsertions += Number(newspaperAll.insertions) || 0;
                  // totalAllRevenue += Number(newspaperAll.revenue) || 0;

                  // totalFiniteClients += Number(newspaperFinite.clients) || 0;
                  // totalFiniteInsertions += Number(newspaperFinite.insertions) || 0;
                  // totalFiniteRevenue += Number(newspaperFinite.revenue) || 0;

                  // totalWay2newsClients += Number(way2newsFinite.clients) || 0;
                  // totalWay2newsInsertions += Number(way2newsFinite.insertions) || 0;
                  // totalWay2newsRevenue += Number(way2newsFinite.revenue) || 0;

                  // totalUnivClients += Number(newspaperUniv.clients) || 0;
                  // totalUnivInsertions += Number(newspaperUniv.insertions) || 0;
                  // totalUnivRevenue += Number(newspaperUniv.revenue) || 0;

                  return (
                    <tr key={index}>
                      <td className="!bg-blue-300">{monthName[0]}</td>
                      <td>{newspaperAll.clients || 0}</td>
                      {/* <td>{newspaperAll.insertions || 0}</td> */}
                      <td>{toLakhs(newspaperAll.revenue || 0)}</td>

                      <td>{newspaperFinite.clients || 0}</td>
                      {/* <td>{newspaperFinite.insertions || 0}</td> */}
                      <td>{toLakhs(newspaperFinite.revenue || 0)}</td>

                      <td>{way2newsFinite.clients || 0}</td>
                      {/* <td>{way2newsFinite.insertions || 0}</td> */}
                      <td>{toLakhs(way2newsFinite.revenue || 0)}</td>

                      <td>{newspaperUniv.clients || 0}</td>
                      {/* <td>{newspaperUniv.insertions || 0}</td> */}
                      <td>{toLakhs(newspaperUniv.revenue || 0)}</td>

                      <td>{clientConv}%</td>
                      {/* <td>{insertConv}%</td> */}
                      <td>{revConv}%</td>
                    </tr>
                  );
                });

                // Total conversion calculations
                // const totalClientConv = totalFiniteClients && totalUnivClients
                //   ? ((totalUnivClients / totalFiniteClients) * 100).toFixed(2)
                //   : "0";

                // const totalInsertConv = totalFiniteInsertions && totalUnivInsertions
                //   ? ((totalUnivInsertions / totalFiniteInsertions) * 100).toFixed(2)
                //   : "0";

                // const totalRevConv = totalFiniteRevenue && totalUnivRevenue
                //   ? ((totalUnivRevenue / totalFiniteRevenue) * 100).toFixed(2)
                //   : "0";

                // return (
                //   <>
                //     {monthRows}
                //     {/* Total Row */}
                //     <tr className="bg-gray-300 font-bold">
                //       <td>Total</td>
                //       <td>{totalAllClients}</td>
                //       {/* <td>{totalAllInsertions}</td> */}
                //       <td>{toLakhs(totalAllRevenue)}</td>

                //       <td>{totalFiniteClients}</td>
                //       {/* <td>{totalFiniteInsertions}</td> */}
                //       <td>{toLakhs(totalFiniteRevenue)}</td>

                //       <td>{totalWay2newsClients}</td>
                //       {/* <td>{totalWay2newsInsertions}</td> */}
                //       <td>{toLakhs(totalWay2newsRevenue)}</td>

                //       <td>{totalUnivClients}</td>
                //       {/* <td>{totalUnivInsertions}</td> */}
                //       <td>{toLakhs(totalUnivRevenue)}</td>

                //       <td>{totalClientConv}%</td>
                //       {/* <td>{totalInsertConv}%</td> */}
                //       <td>{totalRevConv}%</td>
                //     </tr>
                //   </>
                // );
                return monthRows;
              })()}
            </tbody>
          ) : loader ? (
            <TableSkelton rowSpan={15} colspan={11} />
          ) : (
            <NoDataFound colspan={11} />
          )}
        </table>
      </ScrollContainer>
      <SlDrawer
        open={showBrands}
        onSlAfterHide={() => {
          setShowBrands(false);
        }}
        onSlRequestClose={handleRequestClose}
        style={{ "--size": `${window.innerWidth <= 767 ? "100%" : '40%'}` }}
      >
        <div className="flex justify-end mb-4">
          <i className="bi bi-download px-2 py-1 rounded-lg bg-slate-100 hover:bg-yellow-300 cursor-pointer hover:bg-slate-150" data-toggle="tooltip" title="Download"
            onClick={() => downloadBrandWiseData(mergeData, totalForEachbrand, selectedNewspaper)}></i>
        </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Brand Name</th>
              <th>Sales Person</th>
              <th>Brand Location</th>
              <th>Category</th>
              <th>{selectedNewspaper} All</th>
              <th>{selectedNewspaper} Finite</th>
              <th>W2N Finite</th>
              <th>W2N Univ</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(mergeData)?.map((brand) => (
              <tr key={brand}>
                <td title={brand} className="truncate">{brand}</td>
                <td>{mergeData[brand][5]}</td>
                <td>{mergeData[brand][6]}</td>
                <td>{mergeData[brand][4]}</td>
                <td>{formatSpentValue(mergeData[brand][0])}</td>
                <td>{formatSpentValue(mergeData[brand][1])}</td>
                <td>{formatSpentValue(mergeData[brand][2])}</td>
                <td>{formatSpentValue(mergeData[brand][3])}</td>
              </tr>
            ))}
            <tr className="font-bold">
              <td>Total</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>{formatSpentValue(totalForEachbrand['PAM'])}</td>
              <td>{formatSpentValue(totalForEachbrand['PFM'])}</td>
              <td>{formatSpentValue(totalForEachbrand['WFM'])}</td>
              <td>{formatSpentValue(totalForEachbrand['UVM'])}</td>
            </tr>
          </tbody>
        </table>
      </SlDrawer>

    </>
  );
}

export default DailyVsEenadu;
